<template>
  <v-app app>
    <v-main style="background-color: #f0f8f6" class="mb-6">
      <v-container class="pa-0 ma-0" fluid app>
        <v-toolbar
          height="64x"
          flat
          style="z-index: 1"
          class="d-flex justify-end"
        >
          <v-toolbar-items>
            <v-btn
              depressed
              color="white"
              @click="doLogout"
              class="pa-0 flex-grow-1"
            >
              <div>
                <v-icon color="primary">mdi-exit-run</v-icon>
                Выход
              </div>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <slot />
      </v-container>
    </v-main>
    <v-footer></v-footer>
    <v-dialog
      v-model="showNewsHistory"
      max-width="800"
      content-class="rounded-xl ma-2 ma-sm-6"
    >
      <news-history-modal
        @cancel="showNewsHistory = false"
        @open-news="openNews"
      />
    </v-dialog>
    <v-dialog
      v-if="selectedNews"
      v-model="showNewsModal"
      :value="showNewsModal"
      :width="600"
      content-class="rounded-xl ma-2 ma-sm-6"
      persistent
    >
      <news-modal :news="selectedNews" @ok="closeNewsModal" />
    </v-dialog>
  </v-app>
</template>

<script>
import { mapActions } from "vuex";
import NewsHistoryModal from "@/components/NewsHistoryModal.vue";
import NewsModal from "@/components/NewsModal.vue";

export default {
  name: "PatientLayout",
  components: { NewsHistoryModal, NewsModal },
  data() {
    return {
      showNewsHistory: false,
      showNewsModal: false,
      selectedNews: null,
    };
  },
  methods: {
    ...mapActions(["doLogout"]),
    openNews(news) {
      this.selectedNews = news;
      this.showNewsHistory = false;
      this.showNewsModal = true;
    },
    closeNewsModal() {
      this.showNewsModal = false;
      this.selectedNews = null;
    },
  },
};
</script>
